module.exports = __webpack_public_path__ + "img/unesco-2.25e9eec9.png";